import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

const PaginationWrapper = styled.div`
  display: flex;
  width: 100%;
  padding: 20px;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    flex-wrap: wrap;
    padding: 20px 0px;
  }
`;

const PaginationButton = styled.button`
  font-weight: bold;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: ${(props) =>
    props.active ? "var(--color-primary)" : "transparent"};
  color: ${(props) =>
    props.active ? "var(--color-white)" : "var(--color-primary)"};
  margin: 5px 30px;
  &:disabled {
    color: #999;
    cursor: default;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    display: none;
  }
`;

const PaginationItem = styled.div`
  font-weight: bold;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  background: ${(props) =>
    props.active ? "var(--color-primary)" : "transparent"};
  color: ${(props) =>
    props.active ? "var(--color-white)" : "var(--color-primary)"};
  margin: 5px;
  cursor: ${(props) => (props.disabled ? "default" : "pointer")};
  display: flex;
  justify-content: center;
  align-items: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: 35px;
    height: 35px;
  }
`;
const Mobile = styled.div`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
`;

const PaginationButtonMobile = styled.button`
  font-weight: bold;
  border-radius: 50%;
  height: 40px;
  color: var(--color-black);
  background-color: transparent;
  opacity: ${({ $buttonDisabled }) => ($buttonDisabled ? "0.5" : "1")};
  margin: 5px 30px;
  &:disabled {
    color: #999;
    cursor: default;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    margin: 15px 0px;
  }
`;
const PaginationContent = styled.div`
  display: flex;
  width: 100%;
  padding: 20px;
  justify-content: center;
  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    padding: 0px;
  }
`;

const Pagination = ({ products, currentPage, limit, onPageChange }) => {
  const totalProducts = products.length;
  const totalPages = Math.ceil(totalProducts / limit);
  const pageNumbers = [];

  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const handlePageChange = (pageNumber) => {
    onPageChange(pageNumber);
  };

  let visiblePages = [];
  if (totalPages <= 5) {
    visiblePages = pageNumbers;
  } else {
    if (currentPage < 4) {
      visiblePages = pageNumbers.slice(0, 5);
      visiblePages.push("...");
      visiblePages.push(totalPages);
    } else if (currentPage >= 4 && currentPage < totalPages - 2) {
      visiblePages.push(1);
      visiblePages.push("...");
      visiblePages.push(currentPage - 1);
      visiblePages.push(currentPage);
      visiblePages.push(currentPage + 1);
      visiblePages.push("...");
      visiblePages.push(totalPages);
    } else {
      visiblePages.push(1);
      visiblePages.push("...");
      visiblePages = visiblePages.concat(
        pageNumbers.slice(totalPages - 4, totalPages)
      );
    }
  }

  return (
    <PaginationWrapper>
      <Mobile>
        <PaginationButtonMobile
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="previous-page"
          $buttonDisabled={currentPage === 1}
        >
          {"< Tidligere"}
        </PaginationButtonMobile>
        <PaginationButtonMobile
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="next-page"
          $buttonDisabled={currentPage === totalPages}
        >
          {"Neste >"}
        </PaginationButtonMobile>
      </Mobile>
      <PaginationContent>
        <PaginationButton
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="previous-page"
        >
          {"<"}
        </PaginationButton>

        {visiblePages.map((pageNumber, index) => {
          return (
            <React.Fragment key={index}>
              {pageNumber === "..." ? (
                <PaginationItem disabled>{pageNumber}</PaginationItem>
              ) : (
                <PaginationItem
                  onClick={() => handlePageChange(pageNumber)}
                  active={pageNumber === currentPage}
                >
                  {pageNumber}
                </PaginationItem>
              )}
            </React.Fragment>
          );
        })}

        <PaginationButton
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="next-page"
        >
          {">"}
        </PaginationButton>
      </PaginationContent>
    </PaginationWrapper>
  );
};

Pagination.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  currentPage: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
